<template>
    <div>
        <v-btn
            :disabled="!orderIds.length"
            :color="orderIds.length ? 'primary' : 'grey'"
            variant="flat"
            size="x-small"
            data-cy="edit-reservations"
            @click="modal = true"
        >
            {{ $t('edit_reservations') }}
        </v-btn>
        <ModalWrapper v-model="modal" max-width="500">
            <template v-slot:title>
                {{ $t('change_selected_requests') }}
            </template>
            <template v-slot:content>
                <div>
                    <v-autocomplete
                        v-model="requestManager"
                        :items="requestManagerList"
                        :label="$t('request_manager')"
                        item-value="personId"
                        item-title="fullName"
                        clearable
                        color="primary"
                        data-cy="request-manager"
                    />
                    <v-autocomplete
                        v-model="serviceManager"
                        :items="serviceManagerList"
                        :label="$t('service_manager')"
                        item-value="personId"
                        item-title="fullName"
                        clearable
                        color="primary"
                        data-cy="service-manager"
                    />
                    <v-autocomplete
                        v-if="campaigns.length"
                        v-model="campaignId"
                        :items="campaigns"
                        :label="$t('campaigns')"
                        clearable
                        color="primary"
                        data-cy="campaign-id"
                    />
                    <v-select
                        v-if="isTO1"
                        v-model="serviceStatus"
                        :items="serviceStatusesList"
                        :label="$t('status')"
                        clearable
                        color="primary"
                        data-cy="service-status"
                    />
                </div>
            </template>
            <template v-slot:btns>
                <v-btn
                    :loading="isLoading"
                    :disabled="isLoading"
                    color="primary"
                    variant="flat"
                    data-cy="save"
                    @click="save"
                >
                    {{ $t('save') }}
                </v-btn>
            </template>
        </ModalWrapper>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component({
        components: {},
    })
    export class EditReservationsModal extends Vue {
        @Prop({default: [], type: Array}) orderIds
        @Prop({default: [], type: Array}) campaigns

        modal = false
        isLoading = false
        requestManager = null
        requestManagerList = []
        serviceManager = null
        serviceManagerList = []
        serviceStatus = null
        campaignId = null

        async mounted() {
            try {
                const {users} = await this.$api.persons.get({companyId: this.user.person.companyId})
                const roles = ['director', 'sales_manager', 'supervisor', 'sales_staff']

                this.requestManagerList = users
                    // .filter(u => u.role.includes('manager'))
                    .filter(u => roles.includes(u.role.split('.')[1]))
                    .map(u => {
                        u.fullName = [u.firstName, u.lastName].join(' ')
                        return u
                    })
                this.serviceManagerList = this.requestManagerList
                // eslint-disable-next-line no-empty
            } catch (e) {}
        }

        async save() {
            // TODO: add post for mass edit (campaignId)
            this.isLoading = true
            let res = null
            try {
                res = await this.$api.massEditOrders.post({
                    orderIds: this.orderIds,
                    ...(this.requestManager && {orderManagerId: this.requestManager}),
                    ...(this.serviceManager && {serviceManagerId: this.serviceManager}),
                    ...(this.serviceStatus && {status: this.serviceStatus}),
                })
                if (res?.skippedOrdersCount) {
                    this.$toast.warning(this.$t('skipped_orders_count', {prop: res.skippedOrdersCount}), {
                        showClose: true,
                    })
                } else {
                    this.$toast.success(this.$t('success_message.saved_successfully'))
                }
                this.modal = false
                this.$emit('save')
            } catch (e) {
                if (e.msg || e.errors[0].message) {
                    this.$toast.error(e.msg || e.errors[0].message)
                } else this.$toast.error(this.$t('error_message.save_error'))
            } finally {
                this.isLoading = false
            }
        }

        get user() {
            return authStore.user
        }

        get serviceStatusesList() {
            const processStatuses = ['IN_PROGRESS', 'COMPLETED']

            if (this.$conf.public.reservationStatuses.completedAndChecked) processStatuses.push('COMPLETED_AND_CHECKED')
            processStatuses.push('CANCELLED')
            if (this.$conf.public.reservationStatuses.archived) processStatuses.push('ARCHIVED')
            if (this.$conf.public.reservationStatuses.vouchered) processStatuses.push('VOUCHERED')

            return processStatuses.map(value => ({value, title: this.$t(`orderStatus.${value}`)}))
        }

        get isTO1() {
            return authStore.isTO1
        }
    }

    export default EditReservationsModal
</script>
